import { Injectable } from "@angular/core";
import { MapHelperService } from "../../../../services/map-helper.service";
import { EstatusJSON } from "../../shared/models/EstatusJSON";
import { Subject, Subscription } from "rxjs";
import { LayerDTO } from "../models/LayerDTO";
import { EnumLayerTypes } from "../../shared/helpers/enums/EnumLayerTypes";
import { LayerService } from "./Layers.service";

@Injectable({
  providedIn: "root",
})
export class PanelExternalLayerService {
  RegionGeoJson: any;
  ZonesGeoJson: any;
  

  dataGeoJson: any;
  configUrl: string;
  capas = new Array<LayerDTO>();
  capasPivote = new Array<LayerDTO>();

  private intersectedFeatures$: Subject<any> = new Subject<any>();
  private capas$: Subject<LayerDTO[]> = new Subject<LayerDTO[]>();

  isExternalLayersExpanded: boolean = true;
  isExpandCollapseAnimating: boolean = false;

  suscription_GetLayerDataByNameGeoJSON: Subscription;

  constructor(private mapHelper: MapHelperService, private layerCatalogService: LayerService) {
  }

  getIntersectedFeatures(): any {
    return this.intersectedFeatures$.asObservable();
  }

  setIntersectedFeatures(resp) {
    this.intersectedFeatures$.next(resp);
  }

  getLayers(): any {
    return this.capas$.asObservable();
  }

  setGeofenceToggle(resp) {
    this.capas$.next(resp);
  }

  createMapLayer(layer : LayerDTO) {
    var existingLayer = this.mapHelper.GetLayerByName(layer.name + "-layer");
    if (existingLayer != null && existingLayer != undefined) 
      return;
    console.log("MapLayer", layer);

    switch (layer.idLayerType) {
      case EnumLayerTypes.Point:
        this.mapHelper.AddSourceEmptyGeoJson(layer.name + "-source");
        this.mapHelper.AddLayerText(
          layer.name + "text-layer",
          layer.name + "-source",
          layer.atributeDisplay,
          2
        );
        this.mapHelper.AddLayerIcon(
          layer.name + "-layer",
          layer.name + "-source",
          layer.icon,
          this.mapHelper.generalMapIconSize
        );
        break;
      case EnumLayerTypes.Lines:
        this.mapHelper.AddSourceEmptyGeoJson(layer.name + "-source");
        this.mapHelper.AddLayerLine(
          layer.name + "-layer",
          layer.name + "-source"
        );
        break;
      case EnumLayerTypes.Polygon:
        this.mapHelper.AddSourceEmptyGeoJson(layer.name + "-source");
        this.mapHelper.AddLayerPolygons(
          layer.name + "-layer",
          layer.name + "-source"
        );
        this.mapHelper.AddLayerText(
          layer.name + "text-layer",
          layer.name + "-source",
          layer.atributeDisplay,
          -4
        );
        break;
      case EnumLayerTypes.Geofence:
        var existingGeofenceLayer = this.mapHelper.GetLayerByName("geofences-layer");
        if (existingGeofenceLayer != null && existingGeofenceLayer != undefined)
          return;
        this.mapHelper.AddSourceHighEmptyGeoJson(layer.name + "-highsource");
        this.mapHelper.AddSourceEmptyGeoJson(layer.name + "-source");
        this.mapHelper.AddLayerGeofencesPolygons(
          "geofences-layer",
          layer.name + "-source"
        );
        this.mapHelper.AddLayerGeofencesByStatus(
          "geofencesStatus-layer",
          layer.name + "-highsource"
        );
        this.mapHelper.AddLayerTextH3WithStatus(
          "GeofenceText-layer",
          layer.name + "-source",
          "Name"
        );
        break;
      case EnumLayerTypes.ClusterPoints:
        var existingClusterLayer = this.mapHelper.GetLayerByName(layer.name + "-layerCluster");
        if (existingClusterLayer != null && existingClusterLayer != undefined)
          return;
        this.mapHelper.AddSourceClusteredEmptyGeoJson(layer.name + "-source");

        this.mapHelper.AddLayerCluster(
          layer.name + "-layerCluster",
          layer.name + "-source"
        );
        this.mapHelper.AddLayerClusterCount(
          layer.name + "-layerClusterCount",
          layer.name + "-source"
        );

        this.mapHelper.AddLayerUnclusteredPointsV2(
          layer.name + "-layerUnclustered",
          layer.name + "-source",
          layer.icon
        );

        this.mapHelper.AddLayerText(
          layer.name + "textLayer",
          layer.name + "-source",
          layer.atributeDisplay,
          -2
        );
        break;
      case EnumLayerTypes.PrecalculatedPolygon:
        this.mapHelper.AddSourceEmptyGeoJson(layer.name + "-source");
        this.mapHelper.AddLayerCustomizablePolygons(
          layer.name + "-layer",
          layer.name + "-source",
          0.4,
          "#b59df8"
        );
        this.mapHelper.AddLayerLine( 
          layer.name + "-layer-line", 
          layer.name + "-source",
          "#6e3afc",
          3
        );
        this.mapHelper.AddLayerText(
          layer.name + "text-layer",
          layer.name + "-source",
          layer.atributeDisplay,
          -4
        );
      default:
        break;
    }
  }

  //se acciona al presionar el switch de una capa, capaActivada es el evento seleciconado
  onToggleLayer(nameLayer: any) {
    console.log("onToggleExternalLayer capa", nameLayer);
    const filteredLayer = this.capas.find((value) => {
      return value.name == nameLayer;
    });
    if (filteredLayer != undefined) {
      if (!filteredLayer.checked || filteredLayer.checked == null) {
        this.ActivateLayer(nameLayer);
      } else {
        this.DeactivateLayer(nameLayer);
      }
    }
  }

  ActivateLayer(nameLayer: string) {
    console.log("ActivateExternalLayer capa", nameLayer);
    const filteredLayer = this.capas.find((value) => {
      return value.name == nameLayer;
    });
    if (filteredLayer != undefined && !filteredLayer.checked) {
      let obj: any;
      this.setLayerLoading(filteredLayer, true);

      //para regiones que ya se cargaron
      if (nameLayer.includes("egion") && this.RegionGeoJson != null){
        this.mapHelper.UpdateLayerGeoJson( nameLayer + "-source", this.RegionGeoJson );
        filteredLayer.isVisible = true;
        filteredLayer.checked = true;
        this.setLayerLoading(filteredLayer, false);
        return;
      }
      
      //para zonas que ya se cargaron
      if (nameLayer.includes("onas") && this.ZonesGeoJson != null){
        this.mapHelper.UpdateLayerGeoJson( nameLayer + "-source", this.ZonesGeoJson );
        filteredLayer.isVisible = true;
        filteredLayer.checked = true;
        this.setLayerLoading(filteredLayer, false);
        return;
      }

      this.suscription_GetLayerDataByNameGeoJSON = this.layerCatalogService.GetLayerDataByNameGeoJSON( nameLayer, filteredLayer.atributeDisplay).subscribe((data) => {
        let isMinifiedText = true;
        try{
          obj = JSON.parse(data.toString());
          console.log("GetLayerDataByNameGeoJSON", obj);
          
        }catch(e){
          console.log(e);
          isMinifiedText = false;
        }
        if(isMinifiedText){
          data = new EstatusJSON();
          data.result = obj.Result;
          data.isSuccess = obj.IsSuccess;
          data.errors = obj.Errors;
          data.message = obj.Message;
        }
        if (data.isSuccess) {
          console.log("FilteredLayer", filteredLayer);
          try{
            if (filteredLayer.idLayerType == EnumLayerTypes.Geofence) {
            this.mapHelper.UpdateLayerGeoJson( nameLayer + "-highSource", JSON.parse(data.result) );
            this.mapHelper.UpdateLayerGeoJson( nameLayer + "-source", JSON.parse(data.result) );
            }else {
              console.log("Updating*******************************LayerGeoJson", filteredLayer.name + "-source");
              this.mapHelper.UpdateLayerGeoJson( filteredLayer.name + "-source", JSON.parse(data.result) );
              if(nameLayer.includes("egion"))
                this.RegionGeoJson = JSON.parse(data.result);
              if(nameLayer.includes("onas"))
                this.ZonesGeoJson = JSON.parse(data.result);
            }
          }catch(e){
            console.log(e);
          }
          filteredLayer.isVisible = true;
          filteredLayer.checked = true;
          this.setLayerLoading(filteredLayer, false);
          if (this.suscription_GetLayerDataByNameGeoJSON)
            this.suscription_GetLayerDataByNameGeoJSON.unsubscribe();
        }else{
          this.setLayerLoading(filteredLayer, false);
        }    
      });
      if (!this.suscription_GetLayerDataByNameGeoJSON)
            this.setLayerLoading(filteredLayer, false);
    }
    setTimeout(() => {
      this.setLayerLoading(filteredLayer, false);
    }, 40000);
  }

  DeactivateLayer(nameLayer: any) {
    console.log("DeactivateExternalLayer capa", nameLayer);
    const filteredLayer = this.capas.find((value) => {
      return value.name == nameLayer;
    });

    if (filteredLayer != undefined) {
      if (filteredLayer.idLayerType == EnumLayerTypes.Geofence) {
        this.mapHelper.UpdateLayerGeoJson( "Geocercas-highSource", this.mapHelper.Empty_GeoJson );
        this.mapHelper.UpdateLayerGeoJson( nameLayer + "-source", this.mapHelper.Empty_GeoJson );
      } else {
        this.mapHelper.UpdateLayerGeoJson( nameLayer + "-source", this.mapHelper.Empty_GeoJson );
      }
      filteredLayer.isVisible = false;
      filteredLayer.checked = false;
      this.setLayerLoading(filteredLayer, false);
      if (this.suscription_GetLayerDataByNameGeoJSON)
        this.suscription_GetLayerDataByNameGeoJSON.unsubscribe();
    }
  }

  setLayerLoading(layer: LayerDTO, isLoading: boolean) {
    const filteredLayer = this.capas.find((value) => {
      return value.name == layer.name;
    });
    if (filteredLayer != undefined) {
      filteredLayer.isLoading = isLoading;
      this.capas$.next(this.capas);
    }
  }

  clearCheckedLayers(){
    this.capasPivote = this.capas.filter((layer) => { layer.checked});
    this.capas.forEach((layer) => {
      this.DeactivateLayer(layer);
    });
  }

  reactivateClearedLayers(){
    if (this.capasPivote.length > 0) {
      this.capasPivote.forEach((layer) => {
        this.ActivateLayer(layer.name);
      });
      this.capasPivote = [];
    }
  }
}
